import axios from "axios"
const baseUrl = process.env.REACT_APP_API_BASEURL

/**
    * @function sectionQuestionService
    * @param (authToken, indicatorId, submissionId)
    * @description call API to get the section Question list
*/
export const sectionQuestionService = async ({ authToken, indicatorId, submissionId }) => {
    try {
        console.log('[SectionQuestionService] Making API call with params:', {
            indicatorId,
            submissionId,
            baseUrl,
            hasAuthToken: !!authToken
        });
        
        const result = await axios.get(`${baseUrl}users/sectionQuestions/list?indicator=${indicatorId}&submissionId=${submissionId}&filter=Active`, {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        });
        
        console.log('[SectionQuestionService] Full API Response:', {
            status: result.status,
            statusText: result.statusText,
            data: result.data,
            headers: result.headers,
            config: {
                url: result.config.url,
                method: result.config.method
            }
        });
        
        return result;
    } catch (error) {
        console.error('[SectionQuestionService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                url: error.config?.url,
                method: error.config?.method
            }
        });
        throw error;
    }
}

/**
    * @function progressSectionQuestionService
    * @param (authToken, proGress_Dimension, submissionId)
    * @description call API to get the progress section Question list
*/
export const progressSectionQuestionService = async ({ authToken, proGress_Dimension, submissionId }) => {
    const result = await axios.get(`${baseUrl}ProGress/questions/list?proGress_Dimension=${proGress_Dimension}&submissionId=${submissionId}`, {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    })
    return result;
}
